import { ref } from 'vue';
import { defineStore } from 'pinia';
import _cloneDeep from 'lodash/cloneDeep';

import {
  dashboardTabs,
  helpcenterTabs,
  notificationsTabs,
} from '@/constants/tabs';

export interface Tabs {
  dashboard: keyof typeof dashboardTabs;
  helpcenter: keyof typeof helpcenterTabs;
  notifications: keyof typeof notificationsTabs;
}
const defTabs: Tabs = {
  dashboard: 'all',
  helpcenter: 'browse',
  notifications: 'all',
};

// State of tabs that aren't connected to URL
export const useTabsStore = defineStore('tabs', () => {
  const tabs = ref(_cloneDeep(defTabs));

  function $reset(): void {
    tabs.value = _cloneDeep(defTabs);
  }

  return {
    $reset,
    tabs,
  };
});
